function initInfiniteScroll() {
  const container = document.querySelector('#ProductGridContainer');
  const grid = document.querySelector('#product-grid');
  const dataHolder = document.querySelector('#infinite-scroll-data');
  const trigger = document.querySelector('#infinite-scroll-trigger');
  const loader = document.querySelector('#infinite-scroll-loader');

  if (!container || !grid || !dataHolder || !trigger) return;

  if (container.infiniteScrollObserver) {
    container.infiniteScrollObserver.disconnect();
    container.infiniteScrollObserver = null;
  }

  let nextUrl = dataHolder.dataset.nextUrl ? dataHolder.dataset.nextUrl.trim() : '';
  let isLoading = false;

  if (!nextUrl) return;

  const loadMoreProducts = async () => {
    if (!nextUrl || isLoading) return;

    isLoading = true;
    if (loader) loader.hidden = false;

    try {
      const response = await fetch(nextUrl, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load: ${response.status}`);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('#product-grid > li');

      if (!newItems.length) {
        nextUrl = '';
        dataHolder.dataset.nextUrl = '';
        if (container.infiniteScrollObserver) {
          container.infiniteScrollObserver.disconnect();
        }
        return;
      }

      newItems.forEach((item) => {
        grid.appendChild(item);
      });

      const newDataHolder = doc.querySelector('#infinite-scroll-data');
      nextUrl = newDataHolder && newDataHolder.dataset.nextUrl
        ? newDataHolder.dataset.nextUrl.trim()
        : '';

      dataHolder.dataset.nextUrl = nextUrl;

      if (!nextUrl && container.infiniteScrollObserver) {
        container.infiniteScrollObserver.disconnect();
      }

      if (window.Shopify && window.Shopify.PaymentButton) {
        try {
          window.Shopify.PaymentButton.init();
        } catch (e) {}
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);
    } finally {
      isLoading = false;
      if (loader) loader.hidden = true;
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        loadMoreProducts();
      }
    },
    {
      root: null,
      rootMargin: '0px 0px 400px 0px',
      threshold: 0
    }
  );

  observer.observe(trigger);
  container.infiniteScrollObserver = observer;
}

document.addEventListener('DOMContentLoaded', initInfiniteScroll);

document.addEventListener('shopify:section:load', initInfiniteScroll);

document.addEventListener('shopify:section:reorder', initInfiniteScroll);

document.addEventListener('shopify:section:select', initInfiniteScroll);